import { Routes } from '@angular/router';
import { AccordionComponent } from './accordion/accordion.component';
import { WizardComponent } from '../../../containers/main/wizard/wizard.component';
import { LastStepNavComponent } from '../../../shared/navigation/last_step/last_step_nav.component';
import { Testimonial2Component } from '../../testimonials/testimonial2.component';

export const manualSetupRoutes: Routes = [
  {
    path: '',
    children: [
      { path: '', component: Testimonial2Component, outlet: 'side' },
      { path: '', component: WizardComponent, outlet: 'main', children: [
        { path: '',
          component: AccordionComponent,
          outlet: 'stepContent'
        },
        { path: '',
          component: LastStepNavComponent,
          outlet: 'stepNavigation'
        }
      ]
      }
    ]
  }
];
